import { createContext } from "react";

const SexosContext = createContext();

export default SexosContext;
